import { render } from "./MyPersonalGoals.vue?vue&type=template&id=4542d917"
import script from "./MyPersonalGoals.vue?vue&type=script&lang=js"
export * from "./MyPersonalGoals.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__